<template>
  <button
    v-if="iconOnly"
    class="w-10 h-10 rounded"
    :class="props.disabled ? 'bg-gray-50' : 'hover:text-white hover:bg-blue-900 bg-blue-200'"
    :disabled="props.disabled"
  >
    <div class="m-auto w-min h-min">
      <slot></slot>
    </div>
  </button>
  <button
    v-else
    class="py-2 px-4 rounded"
    :class="props.disabled ? 'bg-gray-50' : 'hover:text-white hover:bg-blue-900 bg-blue-200'"
    :disabled="props.disabled"
  >
    <slot></slot>
  </button>
</template>

<script setup lang="ts">
let props = withDefaults(
  defineProps<{
    iconOnly?: boolean;
    disabled?: boolean;
  }>(),
  {
    iconOnly: false,
    disabled: false,
  }
);
</script>
